var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyReportsSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c{fill:none;}.b,.c{stroke:#034ea1;stroke-miterlimit:10;}.c{stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-58 -914)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 25,
    height: 25,
    transform: "translate(58 914)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1266.183 814)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1328.183 103)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 13.573,
    height: 15.714,
    rx: 1,
    transform: "translate(0 3.335)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 3.019,
    transform: "translate(6.88 6.443)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 6.226,
    transform: "translate(3.674 10.156)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 6.226,
    transform: "translate(3.674 13.063)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 6.226,
    transform: "translate(3.674 15.971)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1766.533,9531.016h2.858a.477.477,0,0,0,.476-.477v-14.762a.478.478,0,0,0-.476-.477h-12.616a.478.478,0,0,0-.476.477v2.859",
    transform: "translate(-1752.963 -9515.301)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyReportsSelected);
export default __webpack_public_path__ + "static/media/myReportsSelected.e75920d6c6a663fd6832888292a169cb.svg";
export { ForwardRef as ReactComponent };